import React from "react";

import styles from "./Container.module.scss";

export default function Container({ children, className, style, onClick }) {
  return (
    <div
      className={`${styles.container} ${className}`}
      style={style}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
